import axios from "axios";

const API = axios.create({
  baseURL: process.env.REACT_APP_LOCALHOST,
  headers: {
    "Content-Type": "application/json",
  },
});
export const APICsrf = axios.create({
  // baseURL: 'http://localhost:8000',
  baseURL: 'https://uniquehomekitchens.com/uhk/bepub',
  withCredentials: true, // Include cookies in requests
});

API.interceptors.request.use((config) => {
  const token = localStorage.getItem(process.env.REACT_APP_TOKEN_KEY);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const getCsrfToken = async () => {
  await APICsrf.get('/sanctum/csrf-cookie'); // Adjust the endpoint as needed
};

export default API;
